import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const accessCodeFormStyle: StyleRulesCallback = () => {
  return {
    buttonContainer: {
      justifyContent: 'flex-end',
    },
  };
};

export default accessCodeFormStyle;
